module.exports = __webpack_public_path__ + "assets/img/01.d26e1326.jpg";